import { ConfluencePageAri } from '@atlassian/ari/confluence/page';
const ATLASSIAN_DOMAINS: string[] = [
	'.atlassian.com',
	'.atlassian.net',
	'.jira-dev.com',
	'.jira.com',
	'.atlassian-stg-fedm.net',
	'.atlassian-us-gov-mod.net',
	'.atlassian-us-gov-mod.com',
];

export const isCustomDomain = (hostname: string): boolean =>
	!ATLASSIAN_DOMAINS.some((domain) => hostname.endsWith(domain));

const isValidUrl = (urlString: unknown) => {
	if (typeof urlString !== 'string') {
		return false;
	}
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};

export const getHostnameFromUrl = (url: string): string =>
	isValidUrl(url) ? new URL(url)?.hostname : '';

/**
 * getConfluenceCloudIdFromARI: parses ari for a Confluence page to return cloudId.
 * Only accepts confluence pages
 * @param ari
 * @returns
 */
export const getConfluenceCloudIdFromARI = (ari: string): string | null => {
	if (!ari || typeof ari !== 'string') {
		return null;
	}

	try {
		const parsedAri = ConfluencePageAri.parse(ari);
		return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
	} catch (err) {
		return null;
	}
};

/**
 * getCorrectContentURL: swaps the URL of the preview panel if the parent is a custom domain
 * and the cloud id of the parent and content (they are on the same tenant).
 * Does not include atlassian domains since they already are behind the CSP headers.
 * Only swaps for Confluence pages
 * @param parentCloudId
 * @param url
 * @param ari
 * @returns url
 */
export const getCorrectContentURL = (parentCloudId: string, url: string, ari: string) => {
	const parentHost = getHostnameFromUrl(window?.location?.href) || '';
	const contentHost = getHostnameFromUrl(url);

	if (parentHost === contentHost) {
		return url;
	}

	const cloudId = getConfluenceCloudIdFromARI(ari);

	if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !isCustomDomain(parentHost)) {
		return url;
	}

	// Swap the URL hostname to use the parent's hostname
	try {
		const urlObj = new URL(url);
		urlObj.hostname = parentHost;
		return urlObj.toString();
	} catch (error) {
		// If URL parsing fails, return original URL
		return url;
	}
};
